import { useEffect } from 'react';
import root from 'window-or-global';

const useOnClickOutside = (ref, handler, refToAvoid) => {
  useEffect(() => {
    const listener = event => {
      const { target } = event;
      if (!ref.current || refToAvoid?.current.contains(target) || ref.current.contains(target)) {
        return;
      }

      handler(event);
    };

    // add listeners in capture mode to prevent the target being removed from DOM
    // tree before we have had a chance to check whether the ref contains it
    root.document.addEventListener('click', listener, true);
    root.document.addEventListener('touchstart', listener, true);

    return () => {
      root.document.removeEventListener('click', listener, true);
      root.document.removeEventListener('touchstart', listener, true);
    };
  }, [ref, handler, refToAvoid]);
};

export default useOnClickOutside;
